import React, { PureComponent, Component } from 'react';
import styles from './VideoTabs.css';
import BitBackground from '../../components/BitBackground';
import VideoBoard from '../../components/VideoBoard/';
import AboutTab from '../../components/AboutTab/';
import { env, cdnURL, toTime, getTimestamp } from '../../lib/utils';
import { config, isStage, isDev } from '../../lib/constants';
import YouTubePlayer from 'youtube-player';
import queryString from 'query-string';
import loadJSON from '../../lib/loadLive';
import range from 'lodash/range';
import { gcpURL } from '../../lib/utils';

const IconLeft = `${gcpURL}/static/ig-about-line-left.svg`;
const IconRight = `${gcpURL}/static/ig-about-line-right.svg`;
const IconLoading = `${gcpURL}/static/ig-loading.svg`;
const IconPlay = `${gcpURL}/static/ic-play.svg`;

const { API_URL, defaultLiveOpenID } = config;

class CustomVideo extends Component {
  constructor(props) {
    super(props);
    this.state = { showCover: true };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if(this.props.videoType === 'youtube') {
      this.player = YouTubePlayer(this.props.text, {
        videoId: this.props.videoURL,
        playerVars: {
          rel: 0,
          showinfo: 0,
        },
      });

      this.player.on('stateChange', (event) => {
        const isPlayEnd = 0;
        if(event.data === isPlayEnd) {
          this.setState({ showCover: true });
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { videoType } = this.props;
    const { isActive } = nextProps;
    if (videoType === 'youtube' && isActive === false) {
      this.player.pauseVideo();
    }
  }

  handleClick() {
    this.setState({
      showCover: false
    });

    this.player.playVideo();
  }

  render() {
    const {isActive, videoURL, cover, videoType, text, userIsOnLive} = this.props;
    const {showCover} = this.state;

    const coverStyle = {
      backgroundImage: `url("${cover}")`,
      display: showCover ? 'block' : 'none',
    };

    const coverDisplay = { display: isActive ? 'block' : 'none' };

    return (
      <div className={isActive && videoURL ? styles.videoContainerActive : styles.videoContainer}>
        { videoType === 'youtube' ?
        <div style={coverStyle} className={styles.cover} onClick={this.handleClick}>
          <img style={coverDisplay} className={styles.loadingSvg} src={IconLoading} onClick={this.handleClick}/>
          <img style={coverDisplay} className={styles.playSvg} src={IconPlay} onClick={this.handleClick}/>
          <div style={coverDisplay} className={styles.loadingText} onClick={this.handleClick}>
            立即觀看
          </div>
        </div> : ''}

        {
          videoType === 'live' ?
          <div className={styles.video}>
            { userIsOnLive !== true ?
            <div className={styles.cover} >
              <div style={coverDisplay}>
                <div className={styles.icLineContainer}>
                  {range(19).map((element, index) => <div key={index} className={styles.icLine} />) }
                  {range(11).map((element, index) => <div key={index} className={`${styles.icLine} hideMobile`} />) }
                </div>
                <img className={styles.preparePlaySvg} src={IconLoading} />
                <div className={styles.prepareLoadingText}>
                  { getTimestamp() < toTime('2017-05-28T00:00:00+08:00') ? '05.27 18:00 準時開播' : '直播已結束'}
                </div>
              </div>
            </div> : ''}
            <iframe controls  className={styles.video} src={videoURL} frameBorder="0" allowFullScreen />
          </div>
          : ''
        }
        <div className={styles.video} id={text}></div>
      </div>
    );
  }
}

const VideoOnDemand = ({isActive, videoURL, cover}) => {
  return (
    <div className={isActive && videoURL ? styles.videoContainerActive : styles.videoContainer}>
      <iframe controls className={styles.video} src={videoURL} frameBorder="0" allowFullScreen />
    </div>
  );
};

const toFormData = (obj) => {
  let form_data = new FormData();
  for ( let key in obj ) {
      form_data.append(key, obj[key]);
  }

  return form_data;
};

class VideoTabs extends Component {
  constructor(props) {
    super(props);

    this.apiURL = location.origin;

    if (isDev) {
      this.apiURL = 'http://localhost:8080';
    }

    let liveOpenID = defaultLiveOpenID;
    const parsed = queryString.parse(location.search);
    if(parsed && parsed.liveOpenID) {
      liveOpenID = parsed.liveOpenID;
    }

    this.state = {currentTab: '金羽故事', prepareText: '敬請期待', liveOpenID};
  }

  handleExpand = (target) => () => {
    this.setState(({ expand }) => ({ expand: expand === target ? 0 : target }));
  }

  switchTab = (newFocusTab, videoURL) => (e) => {
    const prepareText = videoURL ? "準備中請稍等" : "敬請期待";
    this.setState({currentTab: newFocusTab, prepareText});
  };

  componentWillMount() {

    const checkLiveStreamStatus = () => {
      const { liveOpenID } = this.state;
      const isLivePeriod = toTime('2017-05-27T14:00:00+08:00') <= getTimestamp() && getTimestamp() < toTime('2017-05-28T00:00:00+08:00');
      console.log(API_URL);
      return fetch(`${API_URL}/api/v1/legacy/getUserInfo`, { method: "POST", body: toFormData({ targetOpenID: liveOpenID }) })
      .then(res => res.json())
      .then(res => JSON.parse(res.data) )
      .then(res => fetch(`${API_URL}/api/v1/liveStreams/isUserOnLiveStream`, { method: "POST", body: toFormData({ targetUserID: res.userID }) }))
      .then(res => res.json())
      .then(res => JSON.parse(res.data) )
      .then(({userIsOnLive}) => {
        if (userIsOnLive === 1 && this.state.userIsOnLive !== true) {
          if (isDev || isStage || isLivePeriod) {
            this.setState({ userIsOnLive: true, currentTab: "典禮直播" });
          }
        }

      })
      .catch(e => console.error(e));
    };

    loadJSON().then(data => {
      this.setState({liveOpenID: data.liveOpenID}, () => {
        console.log("Set liveOpenID", this.state.liveOpenID);
        checkLiveStreamStatus();
      });

    })

    this.checkLiveStreamStatusTimer = setInterval(checkLiveStreamStatus, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.checkLiveStreamStatusTimer);
  }

  render() {
    const { userIsOnLive, currentTab, prepareText, toolTipStyle, liveOpenID} = this.state;
    const aboutTab = [
      { text: "歷史回顧",
        videoType: 'youtube',
        videoURL: "iJW2VS1jMVw",
        cover: `${cdnURL}ig_history_default.png`,
      },
      {
        text: "金羽故事",
        videoType: 'youtube',
        videoURL: "IzRXpOhuQJ0",
        cover: `${cdnURL}ig_story_default.png`,
      },
    ];

    if (isDev) {
      aboutTab.push({ text: "典禮直播", videoType: 'live', videoURL: `${this.apiURL}/share/live_user/${liveOpenID}` });
    } else {
      aboutTab.push({ text: "典禮直播", videoType: 'live', videoURL: `${this.apiURL}/share/live_user/${liveOpenID}` });
    }

    return (
      <section className={styles.videoTabs}>
        <div className={styles.tabContainer}>
          {aboutTab.map(({ text, videoURL, isDisabled, cursor }, index) => (
            <AboutTab
              text={text}
              key={index}
              isActive={currentTab === text}
              onClick={ isDisabled ? () => {} : this.switchTab(text, videoURL) }
              isDisabled={isDisabled}
              cursor={cursor}
            />
          ))}
        </div>

        <VideoBoard text={prepareText}>
          {aboutTab.map(({text, videoURL, cover, videoType}, index) => (
            <CustomVideo userIsOnLive={userIsOnLive} videoType={videoType} text={text}
            cover={cover} key={index} videoURL={videoURL} isActive={currentTab === text}/>
          ))}
        </VideoBoard>
        <img className={styles.bgIconLeft} src={IconLeft} />
        <img className={styles.bgIconRight} src={IconRight} />
        <BitBackground className={styles.bitBackground} />
      </section>
    );
  }
}

export default VideoTabs;



// WEBPACK FOOTER //
// ./src/sections/VideoTabs/index.js